import { createSlice } from "@reduxjs/toolkit";
import localStorage from "redux-persist/es/storage";

const getPermissions = (user) => user?.role?.permissions?.map((permission) => permission?.slug);

const initialAuthState = {
  token: typeof localStorage.getItem("token") === "string" ? localStorage.getItem("token") : null,
  actionLoading: false,
  listLoading: false,
  user: null,
  userPermissions: [],
  isAuthorized: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialAuthState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = true;
      } else {
        state.listLoading = true;
      }
    },
    stopCall: (state, action) => {
      if (action.payload === "action") {
        state.actionLoading = false;
      } else {
        state.listLoading = false;
      }
    },
    login: (state, action) => {
      const { user, tokens } = action.payload;
      state.user = user;
      state.token = tokens.access.token;
      state.userPermissions = getPermissions(user);
      state.actionLoading = false;
      state.isAuthorized = true;
    },
    logout: (state, action) => {
      localStorage.removeItem("token");
      state.token = false;
      state.actionLoading = false;
      state.listLoading = false;
      state.user = null;
      state.isAuthorized = false;
      state.notificationMessage = "";
    },
    loadUserByToken: (state, action) => {
      const { user } = action.payload;
      state.actionLoading = false;
      state.userPermissions = getPermissions(user);
      state.user = user;
      state.isAuthorized = true;
    },
  },
});
